import type { AdminUser } from '../types';
import { Icon, Avatar } from '../atoms';

export function Approvals({ users, onOpen, act }: {
  users: AdminUser[];
  onOpen: (u: AdminUser) => void;
  act: (type: string, user: AdminUser) => void;
}) {
  const pending = users.filter(u => u.status === 'pending');

  return (
    <>
      <div className="sec-h">
        <h2>Registration queue</h2>
        <span className="c">{pending.length} awaiting review</span>
        <div className="grow" />
      </div>
      <p style={{ color: 'var(--soft)', maxWidth: 640, margin: '-6px 2px 18px', fontSize: 14 }}>
        Anyone can register and use Jotly immediately on the free tier (100k tokens · £3 AI cap).
        Approving lifts their caps. Decline blocks the account without deleting the sign-up.
      </p>
      {pending.length ? (
        <div className="stack">
          {pending.map(u => (
            <div className="appcard" key={u.id}>
              <Avatar size={44} hue={u.hue} initials={u.initials} />
              <div className="who" onClick={() => onOpen(u)} style={{ cursor: 'pointer' }}>
                <div className="n">
                  {u.name}
                  {u.flags.includes('dupe') && (
                    <span className="badge bad"><span className="d" />Duplicate signal</span>
                  )}
                </div>
                <div className="m">{u.email} · registered {u.joined}</div>
              </div>
              <div className="acts">
                <button className="btn" onClick={() => act('decline', u)}>Decline</button>
                <button className="btn pri" onClick={() => act('approve', u)}>
                  <Icon name="check" size={15} />Approve
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="card" style={{ padding: 40, textAlign: 'center', color: 'var(--soft)' }}>
          <Icon name="check" size={26} style={{ color: 'var(--ok)' }} />
          <p style={{ marginTop: 10 }}>Queue is empty — every registration has been reviewed.</p>
        </div>
      )}
    </>
  );
}
